import {Panes, prefixWithSeparator, TextField} from '@management-ui/core';
import {Autocomplete, Box, FormControl, InputLabel, MenuItem, Select, TextField as MUITextField} from '@mui/material';
import React, {useContext, useEffect, useRef, useState} from 'react';
import {useFormContext} from 'react-hook-form';
import {ServiceContext} from '../../../../components/Services';
import {joinAddress, saveDate} from '../../../../utilities';

const Collection = ({order = {}, prefix = ''}) => {
  const services = useContext(ServiceContext);
  const [contacts, setContacts] = useState([]);
  const [contact, setContact] = useState(null);
  const [location, setLocation] = useState('');
  const initialised = useRef(false);
  const {setValue} = useFormContext();

  useEffect(() => {
    if (!initialised.current) {
      initialised.current = true;
      services.contact.getCachedContacts()
        .then(response => setContacts(response.data))
        .catch(() => setContacts([]));
    }
  }, [services]);

  useEffect(() => {
    if (contact) {
      const index = contact.locations.findIndex(({id}) => `${id}` === location);
      if (index >= 0) {
        setValue(`${prefixWithSeparator(prefix)}collection_address`, joinAddress(contact.locations[index], [contact.name]));
      }
    }
  }, [prefix, contact, location, setValue]);

  return (
    <Panes
      entity={order}
      prefix={prefix}
      panes={[
        {
          title: 'Collection Address',
          fields: [
            <Box marginY={2}>
              <Autocomplete
                options={contacts}
                value={contact}
                onChange={(e, selected) => setContact(selected)}
                renderInput={(params) => <MUITextField {...params} label="Contact"/>}
                getOptionLabel={(option) => option.name}
              />
            </Box>,
            <Box marginY={2}>
              <FormControl fullWidth disabled={(contact?.locations ?? []).length < 1}>
                <InputLabel id="locationLabel">Location</InputLabel>
                <Select
                  labelId="locationLabel"
                  value={location}
                  label="Location"
                  onChange={(e) => setLocation(e.target.value)}
                >
                  {(contact?.locations ?? []).map((l, i) => (
                    <MenuItem key={i} value={`${l.id}`}>{l.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>,
            <TextField
              name="collection_address"
              prefix={prefix}
              label="Collection Address"
              fieldProps={{multiline: true, rows: 4}}
            />,
          ]
        },
        {
          title: '',
          fields: []
        }
      ]}
      title=""
    />
  );
};

Collection.onSave = ({collection_address, collection_date}) => ({
  collection_address,
  collection_date: saveDate(collection_date)
});

export default Collection;
